const hashStringToUint32 = (value: string): number => {
  let hash = 2166136261
  for (let i = 0; i < value.length; i += 1) {
    hash ^= value.charCodeAt(i)
    hash = Math.imul(hash, 16777619)
  }
  return hash >>> 0
}

export const createMockSteamId = (seedValue: string): string => {
  const hash = hashStringToUint32(seedValue || 'steam-mock')
  const suffix = String(hash).padStart(10, '0').slice(0, 10)
  return `7656119${suffix}`
}

export const isSteamMockEnabled = (): boolean =>
  import.meta.env?.VITE_STEAM_MOCK_ENABLED === 'true'
